/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Blocked_Plan_ChangeInputs */

const fr_membership_freeze_blocked_plan_change = /** @type {(inputs: Membership_Freeze_Blocked_Plan_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause indisponible tant qu'un changement d'abonnement est programmé.`)
};

/**

* @param {Membership_Freeze_Blocked_Plan_ChangeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_blocked_plan_change = /** @type {((inputs?: Membership_Freeze_Blocked_Plan_ChangeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Blocked_Plan_ChangeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_blocked_plan_change(inputs)
});